.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 240px;
  max-width: 440px;
  padding: 12px 16px;
  border-radius: 10px;
  background: var(--ds-background);
  border: 1px solid var(--ds-pearl-grey);
}

.icon {
  flex-shrink: 0;
  font-size: 18px;
}

.success .icon {
  color: var(--ds-green);
}

.failure .icon {
  color: var(--ds-red);
}

.message {
  flex: 1;
  color: var(--ds-black);
}

.dismiss {
  flex-shrink: 0;
  padding: 4px;
  color: var(--ds-grey);

  &:hover {
    color: var(--ds-black);
  }
}
